var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricIconYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD110",
    fillRule: "nonzero",
    d: "M15 0C6.718 0 0 6.718 0 15s6.718 15 15 15 15-6.718 15-15S23.282 0 15 0zm-.782 27.024v-9.409h-5.23l7.515-14.639v9.409h5.035l-7.32 14.639z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricIconYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/electric-icon_yellow.286b007d7296f05c26b3bb1fc6068758.svg";